/* Country delivery information is independent of the selected size and bag. */
(function () {
  'use strict';
  if (window.dsrcvPdpDeliveryReturns) return;
  window.dsrcvPdpDeliveryReturns = true;
  var generation = 0, controller, deadline, expiry, retry, refresh;
  var activeKey = '', pending = false, failures = 0;
  var proofs = new Map(), storageKey = 'dsrcv:pdp-delivery:v1';
  var defaults = new WeakMap();
  function roots() {
    return Array.from(document.querySelectorAll('[data-pdp-delivery-returns]')).map(function (root) {
      if (!defaults.has(root)) {
        var price = root.querySelector('[data-pdp-delivery-price]');
        var transit = root.querySelector('[data-pdp-delivery-transit]');
        defaults.set(root, {transit: transit ? transit.textContent : '', price: price && price.hasAttribute('data-pdp-delivery-fallback') ? price.textContent : ''});
      }
      return root;
    });
  }
  function context(root) {
    var shopify = window.Shopify || {};
    return {
      country: shopify.country && shopify.country !== root.dataset.country ? '' : String(root.dataset.country || '').toUpperCase(),
      currency: String((shopify.currency || {}).active || root.dataset.currency || '').toUpperCase()
    };
  }
  function fit(root) {
    var inner = root.closest('.Collapsible__Inner'), box = root.closest('.Collapsible');
    if (inner && box && inner.style.height !== 'auto' && box.querySelector('[aria-expanded="true"]')) inner.style.height = inner.scrollHeight + 'px';
  }
  function clear(root, resetTransit) {
    var price = root.querySelector('[data-pdp-delivery-price]'), transit = root.querySelector('[data-pdp-delivery-transit]');
    var initial = defaults.get(root) || {}, current = context(root);
    var sameCountry = current.country === root.dataset.country;
    var fallbackPrice = sameCountry && current.currency === root.dataset.currency ? initial.price || '' : '';
    if ((resetTransit === true || root.dataset.summaryStatus === 'available') && transit) transit.textContent = sameCountry ? initial.transit || root.dataset.transitFallback || '' : root.dataset.transitFallback || '';
    if (price) { price.textContent = fallbackPrice; price.hidden = !fallbackPrice; }
    root.dataset.summaryStatus = fallbackPrice ? 'fallback' : 'unavailable'; delete root.dataset.summaryProof; fit(root);
  }
  function valid(summary, expected, allowExpired) {
    return summary && summary.available === true &&
      summary.countryCode === expected.country && summary.currency === expected.currency &&
      Number.isSafeInteger(summary.basePriceCents) && summary.basePriceCents >= 0 &&
      Number.isSafeInteger(summary.freeThresholdCents) && summary.freeThresholdCents >= 0 &&
      (summary.basePriceCents === 0) === (summary.freeThresholdCents === 0) &&
      typeof summary.methodLabel === 'string' && summary.methodLabel.trim() !== '' &&
      typeof summary.transitWindowLabel === 'string' && summary.transitWindowLabel.trim() !== '' &&
      summary.scope === 'country_standard_service' &&
      ['canonical_gbp_country_summary', 'shopify_native_country_summary'].includes(summary.source) &&
      (summary.source !== 'canonical_gbp_country_summary' || summary.currency === 'GBP') &&
      typeof summary.expiresAt === 'string' && Number.isFinite(Date.parse(summary.expiresAt)) &&
      (allowExpired || Date.parse(summary.expiresAt) > Date.now());
  }
  function money(cents, currency, roundUp) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currencyDisplay: 'narrowSymbol', currency: currency, minimumFractionDigits: roundUp || cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
    }).format(roundUp ? Math.ceil(cents / 100) : cents / 100);
  }
  function timing(root, label) {
    if (/^Delivered Next Day Once Dispatched$/i.test(label.trim())) return root.dataset.nextDayTemplate;
    var value = label.trim().replace(/^Standard Shipping\s*\|\s*/i, '');
    var match = value.match(/^(\d{1,2})(?:\s*[-–]\s*(\d{1,2})|(\+))?\s*Days(?:\s*\(No Import Charges On Delivery\))?$/i);
    var last = match && Number(match[2] || match[1]);
    if (!match || Number(match[1]) < 1 || last < Number(match[1]) || last > 90) return root.dataset.transitFallback;
    var days = match[3] ? match[1] + '+' : Number(match[1]) === last ? match[1] : match[1] + '–' + match[2];
    return (root.dataset.transitTemplate || '').replace('{days}', days);
  }
  function show(root, summary, expected) {
    var current = context(root), price = root.querySelector('[data-pdp-delivery-price]');
    if (!price || current.country !== expected.country || current.currency !== expected.currency || !valid(summary, expected)) return;
    var template = summary.freeThresholdCents === 0 ? root.dataset.freeTemplate : root.dataset.priceTemplate;
    if (!template) return;
    price.textContent = template.replace('{price}', money(summary.basePriceCents, expected.currency))
      .replace('{threshold}', money(summary.freeThresholdCents, expected.currency, expected.currency === 'USD' || expected.currency === 'EUR'));
    var transit = root.querySelector('[data-pdp-delivery-transit]');
    if (transit) transit.textContent = timing(root, summary.transitWindowLabel) || root.dataset.transitFallback || '';
    price.hidden = false; root.dataset.summaryStatus = 'available';
    root.dataset.summaryProof = JSON.stringify({countryCode:summary.countryCode,currency:summary.currency,basePriceCents:summary.basePriceCents,freeThresholdCents:summary.freeThresholdCents,methodLabel:summary.methodLabel,transitWindowLabel:summary.transitWindowLabel,source:summary.source,scope:summary.scope,rulesVersion:summary.rulesVersion,expiresAt:summary.expiresAt});
    fit(root);
  }
  function readProof(expected) {
    var key = expected.country + ':' + expected.currency, proof = proofs.get(key);
    if (!proof) {
      try {
        var stored = window.sessionStorage.getItem(storageKey);
        if (stored && stored.length < 16384) proof = JSON.parse(stored)[key];
      } catch (error) { /* Storage can be disabled in private browsing. */ }
    }
    if (!valid(proof, expected)) { proofs.delete(key); return null; }
    proofs.set(key, proof); return proof;
  }
  function saveProof(expected, proof) {
    proofs.set(expected.country + ':' + expected.currency, proof);
    while (proofs.size > 8) proofs.delete(proofs.keys().next().value);
    var stored = {};
    proofs.forEach(function (value, key) {
      if (Date.parse(value.expiresAt) <= Date.now()) proofs.delete(key);
      else stored[key] = value;
    });
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(stored)); } catch (error) { /* In-memory recovery still works. */ }
  }
  function cancelTimers() {
    window.clearTimeout(expiry); window.clearTimeout(deadline);
    window.clearTimeout(retry); window.clearTimeout(refresh); retry = null;
  }
  function update(force) {
    var all = roots();
    if (!all.length) return;
    var first = all[0], expected = context(first), endpoint = first.dataset.summaryEndpoint;
    var key = expected.country + ':' + expected.currency;
    if (key !== activeKey) {
      ++generation; cancelTimers(); if (controller) controller.abort();
      activeKey = key; pending = false; failures = 0;
    }
    var currentGeneration = generation, proof = readProof(expected);
    all.forEach(function (root) { if (proof) show(root, proof, expected); else clear(root, true); });
    if (!endpoint || !/^[A-Z]{2}$/.test(expected.country) || !/^[A-Z]{3}$/.test(expected.currency)) return;
    var url;
    try {
      url = new URL(endpoint);
      if (url.origin !== 'https://core.dsrcv.com' || url.pathname !== '/api/shopify/storefront-delivery-progress') return;
    } catch (error) { return; }
    function scheduleProof(summary) {
      window.clearTimeout(expiry); window.clearTimeout(refresh);
      var remaining = Date.parse(summary.expiresAt) - Date.now();
      expiry = window.setTimeout(function () {
        if (currentGeneration !== generation) return;
        roots().forEach(function (root) { if (!readProof(expected)) clear(root, true); });
        if (!pending && !retry && document.visibilityState !== 'hidden') update(true);
      }, Math.max(0, remaining));
      // Renew before expiry so a healthy lookup does not make the price blink.
      if (remaining > 10000) refresh = window.setTimeout(function () {
        if (currentGeneration === generation && document.visibilityState !== 'hidden') update(true);
      }, remaining - 10000);
    }
    if (proof) scheduleProof(proof);
    if (pending || document.visibilityState === 'hidden' || window.navigator.onLine === false) return;
    if (!force && retry) return;
    if (!force && proof && Date.parse(proof.expiresAt) > Date.now() + 10000) return;
    window.clearTimeout(retry); retry = null;
    pending = true;
    url.search = new URLSearchParams({view:'country_summary', country:expected.country, currency:expected.currency}).toString();
    controller = typeof AbortController === 'function' ? new AbortController() : null;
    var requestController = controller;
    var timeout = new Promise(function (_, reject) {
      deadline = window.setTimeout(function () {
        if (requestController) requestController.abort();
        var error = new Error('country_summary_timeout'); error.retryable = true; reject(error);
      }, 35000);
    });
    var request = Promise.resolve().then(function () {
      return fetch(url.toString(), {method:'GET', credentials:'omit', mode:'cors', cache:'no-store',
        headers:{Accept:'application/json'}, signal:requestController ? requestController.signal : undefined});
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error('country_summary_unavailable');
        error.retryable = [408, 429, 500, 502, 503, 504].includes(response.status);
        var wait = response.headers && Number(response.headers.get('Retry-After'));
        if (Number.isFinite(wait) && wait > 0) error.retryAfter = Math.min(60000, wait * 1000);
        throw error;
      }
      return response.json();
    });
    Promise.race([request, timeout]).then(function (payload) {
      if (currentGeneration !== generation) return;
      var summary = payload && payload.summary;
      if (!valid(summary, expected)) {
        var error = new Error('country_summary_invalid');
        error.retryable = summary && (summary.reason === 'country_summary_temporarily_unavailable' || valid(summary, expected, true));
        throw error;
      }
      failures = 0; saveProof(expected, summary);
      roots().forEach(function (root) { show(root, summary, expected); });
      scheduleProof(summary);
    }).catch(function (error) {
      if (currentGeneration !== generation) return;
      var current = readProof(expected);
      roots().forEach(function (root) { if (current) show(root, current, expected); else clear(root, true); });
      if (error && (error.retryable || error.name === 'TypeError' || error.name === 'AbortError')) {
        var wait = Math.max(error.retryAfter || 0, [1000, 3000, 10000][failures++] || 60000);
        retry = window.setTimeout(function () {
          retry = null;
          if (currentGeneration === generation) update(true);
        }, wait);
      }
    }).finally(function () {
      if (currentGeneration === generation) { pending = false; window.clearTimeout(deadline); }
    });
  }
  ['ajax-product:loaded', 'currency:change', 'covCurrency:updated', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, function () { update(false); });
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') update(false);
  });
  window.addEventListener('online', function () { update(true); });
  window.addEventListener('pageshow', function () { update(false); });
  window.addEventListener('pagehide', function () {
    ++generation; cancelTimers(); activeKey = ''; pending = false;
    if (controller) controller.abort();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { update(false); }, {once:true});
  else update(false);
})();
